const index = [{
  path: 'project/detail/:projectId',
  component: resolve => require(['../../../../components/pages/register/project/prodetail'], resolve)
}, {
  path: 'project/report/:classId',
  component: resolve => require(['../../../../components/pages/register/project/report'], resolve)
}, {
  path: 'project/resuccess',
  component: resolve => require(['../../../../components/pages/register/project/resuccess'], resolve)
}]
export default index
